import { Form, Modal } from "antd";
import React from "react";
import { CreateMaterialDto } from "../../../api";
import { materialsColumns } from "../form/columns";

interface MaterialFormProps {
  visible: boolean;
  setVisible: Function;
  onCreateMaterial: (values: CreateMaterialDto) => void;
}

export const MaterialForm: React.FC<MaterialFormProps> = ({ visible, setVisible, onCreateMaterial }) => {
  const [form] = Form.useForm<CreateMaterialDto>();

  return (
    <Modal open={visible} onOk={form.submit} okText="Создать" cancelText="Отмена" onCancel={() => setVisible(false)}>
      <Form form={form} className="p-8" layout="vertical" onFinish={onCreateMaterial}>
        {materialsColumns.map(({ title, dataIndex, rules, inputNode }, index) => (
          <Form.Item label={title} name={dataIndex} rules={rules} key={index}>
          {inputNode}
          </Form.Item>
        ))}
      </Form>
    </Modal>
  );
};
